import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 96 96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M47.9.3C74.1.2 95.5 21.6 95.7 48c.2 26.2-21.4 47.8-47.8 47.8C21.6 95.8.1 74.3.1 48 .2 21.8 21.5.4 47.9.3ZM5.6 48.1c-.1 23.1 18.7 42.1 41.9 42.3 23.3.2 42.4-18.6 42.5-42C90.2 25 71.2 6 47.8 5.9c-23.1-.1-42 18.8-42.2 42.2Z" }, null, -1),
    _createElementVNode("path", { d: "M27.1 60.8c.3-.9.5-1.9 1-2.7.6-1 1.7-1.1 2.8-.9 1 .3 1.7 1 1.9 2.1.2 1.3.2 2.7.6 4 2 8.1 9.8 13 17.9 11.2C58 73 62.7 67.3 63 60.1c.1-1.6.8-2.7 2.1-3 1.8-.4 3.3.9 3.3 2.8 0 5-1.7 9.5-4.9 13.3-4 4.7-9.1 7.1-15.2 7.2-11.3.2-20.2-8.2-21-19.6 0 .1-.1.1-.2 0ZM32.1 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" }, null, -1),
    _createElementVNode("path", {
      d: "M64.4 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z",
      opacity: ".8"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SmileyRate4"}) } }